import TcCheckbox from 'components/UI/Checkbox/TcCheckbox';
import TcModal from 'components/UI/Modal/TcModal';
import SlateEditor from 'components/UI/SlateEditor/SlateEditor';
import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { termsAndCondition } from 'global/Models/termsAndConditions';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { DOMAIN, errorResponse } from 'global/utils/ApiService';
import { useEffect, useMemo, useState } from 'react';
import { MdBalance } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { userHandleLogout } from 'redux/reducer/user/userReducer';
import { RootState, store } from 'redux/store';

const TermsAndCondition = () => {
  //state
  const { customerUser } = useSelector((state: RootState) => state.user);
  const [isAcceptTermsAndCondition, setIsAcceptTermsAndCondition] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [termsAndConditionDetail, setTermsAndConditionDetail] = useState<termsAndCondition>();
  const [richTextValue, setRichTextValue] = useState<any[]>([]);
  const [modalType, setModalType] = useState<'terms' | 'updates' | 'product' | null>(null);

  //effect
  useEffect(() => {
    customerUser && customerUser.customerId && checkCustomerAcceptedTermsAndCondition();
  }, [customerUser]);

  //func
  //after customer log in check termsAndCondition
  const checkCustomerAcceptedTermsAndCondition = async () => {
    await ApiService.post(endpointUrls.checkCustomerTermsAndCondition, { customerId: customerUser?.customerId })
      .then((res: IBackendGetGeneric<termsAndCondition[]>) => {
        if (res.statusCode == 'TermsAndConditionIsNotAccepted' && res.data) {
          const terms = res.data?.find((item: any) => item.termsAndConditionsTypeId === 1);
          const updates = res.data?.find((item: any) => item.termsAndConditionsTypeId === 2);
          const product = res.data?.find((item: any) => item.termsAndConditionsTypeId === 4);
          if (terms) {
            setTermsAndConditionDetail(terms);
            setModalType('terms');
            setIsAcceptTermsAndCondition(true);
            setRichTextValue(JSON.parse(terms.content) || []);
          } else if (updates) {
            setTermsAndConditionDetail(updates);
            setModalType('updates');
            setIsAcceptTermsAndCondition(true);
            setRichTextValue(JSON.parse(updates.content) || []);
          } else if (product) {
            setTermsAndConditionDetail(product);
            setModalType('product');
            setIsAcceptTermsAndCondition(true);
            setRichTextValue(JSON.parse(product.content) || []);
          } else {
            setIsAcceptTermsAndCondition(false);
          }
        } else {
          setIsAcceptTermsAndCondition(false);
        }
      })
      .catch(() => localApiCatcher(errorResponse));
  };

  const acceptTermsAndCondition = async () => {
    await ApiService.post(endpointUrls.acceptTermsAndConditions, {
      termsAndConditionsTypeId: termsAndConditionDetail?.termsAndConditionsTypeId,
      termsAndConditionId: termsAndConditionDetail?.id,
      customerId: customerUser?.customerId,
    })
      .then((res: IBackendGetGeneric<termsAndCondition>) => {
        handleApiThenGeneric<IBackendGetGeneric<termsAndCondition>, termsAndCondition>({
          res,
          notifFail: true,
          notifSuccess: true,
          onSuccessData: () => {
            if (modalType === 'terms') {
              checkCustomerAcceptedTermsAndCondition();
            } else {
              setIsAcceptTermsAndCondition(false);
            }
            setIsChecked(false);
          },
        });
      })
      .catch(() => localApiCatcher(errorResponse));
  };

  const logOutCustomer = () => {
    setIsAcceptTermsAndCondition(false);
    setIsChecked(false);
    store.dispatch(userHandleLogout());
    // push(routes.login.path);
  };

  const renderButton = useMemo(() => {
    if (isChecked)
      return (
        <span onClick={acceptTermsAndCondition} className='px-3 py-1 border rounded-md cursor-pointer text-t-secondary-color border-t-secondary-color'>
          ادامه
        </span>
      );

    return <span className='px-3 py-1 border rounded-md cursor-not-allowed border-t-border-color-base text-t-secondary-text-color '>ادامه</span>;
  }, [isChecked]);

  return (
    <>
      {modalType !== 'product' && (
        <TcModal title={modalType === 'terms' ? 'قوانین و ضوابط' : 'تغییرات سامانه تیپاکس'} footer={false} visible={isAcceptTermsAndCondition} width={850}>
          <div className='flex items-center py-3'>
            <MdBalance className='text-2xl ' />
            <span className='mx-1 text-sm font-medium'>
              {modalType === 'terms'
                ? 'کاربر گرامی تا زمانی که قوانین و مقررات را نپذیرید امکان استفاده از سامانه را نخواهید داشت.'
                : 'کاربر گرامی، لطفاً تغییرات جدید سامانه را مطالعه و تأیید کنید.'}
            </span>
          </div>
          <div className='overflow-auto h-[34rem] termsAndCondition bg-t-layer-bg-color rounded-lg'>
            <SlateEditor value={richTextValue} setValue={() => {}} readOnly bgColor='bg-t-layer-bg-color' />
          </div>
          <div className='flex justify-between pt-3 gap-x-2'>
            <div className='flex items-center gap-2'>
              <TcCheckbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} id='isCheckedTermsAndConditions' />
              <label className='text-sm select-none ' htmlFor='isCheckedTermsAndConditions'>
                {modalType === 'terms' ? 'شرایط و قوانین را مطالعه کرده و موافقم.' : 'مطالعه شد!'}
              </label>
            </div>
            <div className='flex gap-x-2'>
              <span onClick={logOutCustomer} className='px-3 py-1 border rounded-md cursor-pointer border-t-text-color'>
                خروج
              </span>
              {renderButton}
            </div>
          </div>
        </TcModal>
      )}
      {modalType === 'product' && (
        <TcModal title={'لیست ممنوعات'} footer={false} visible={isAcceptTermsAndCondition} width={800}>
          <div className='flex items-center py-3'>
            <MdBalance className='text-2xl ' />
            <span className='mx-1 text-sm font-medium'>کاربر گرامی لطفا فایل‌های کالا یا اجناس ممنوعه پیوست شده را دانلود و مطالعه کنید.</span>
          </div>
          {termsAndConditionDetail?.attachments && termsAndConditionDetail.attachments.length > 0 && (
            <div className='p-4 mb-4 border border-gray-200 rounded bg-gray-50'>
              <h4 className='mb-2 text-sm font-bold'>فایل‌های پیوست شده قبلی:</h4>
              {termsAndConditionDetail.attachments.map((url, index) => (
                <li key={index} className='mb-1'>
                  <a
                    href={DOMAIN + url}
                    className='flex items-center gap-2 text-blue-600 hover:underline'
                    target='_blank'
                    rel='noreferrer'
                    download
                    type='application/octet-stream'>
                    <span>دانلود فایل پیوست {index + 1}</span>
                  </a>
                </li>
              ))}
            </div>
          )}
          <div className='flex justify-between pt-3 gap-x-2'>
            <div className='flex items-center gap-2'>
              <TcCheckbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} id='isCheckedTermsAndConditions' />
              <label className='text-sm select-none ' htmlFor='isCheckedTermsAndConditions'>
                مطالعه شد
              </label>
            </div>
            <div className='flex gap-x-2'>
              <span onClick={logOutCustomer} className='px-3 py-1 border rounded-md cursor-pointer border-t-text-color'>
                خروج
              </span>
              {renderButton}
            </div>
          </div>
        </TcModal>
      )}
    </>
  );
};

export default TermsAndCondition;
